import { SectionModuleTypeEnum } from "@/scripts/common/enums.js";
import { createTextModule, setHorizontalAlignment } from "@/scripts/common/layoutConfigurations.js";

function getFooterHorizontalAlignment(footer) {
    return footer?.styleSettings?.boxAlign?.split("-")?.[0] || "left";
}

export function createDefaultFooterTextModule() {
    return createTextModule(1, 9, 12);
}

export function createDefaultFooterModules(footer) {
    return setHorizontalAlignment([createDefaultFooterTextModule()], getFooterHorizontalAlignment(footer));
}

export function ensureFooterLayoutSettings(footer) {
    if (!footer) return null;

    if (!footer.layoutSettings) {
        footer.layoutSettings = {
            modules: createDefaultFooterModules(footer),
            totalColumns: 12
        };
    }

    if (!Array.isArray(footer.layoutSettings.modules) || footer.layoutSettings.modules.length < 1) {
        footer.layoutSettings.modules = createDefaultFooterModules(footer);
    }

    return footer.layoutSettings;
}

export function getFooterModules(footer) {
    return ensureFooterLayoutSettings(footer)?.modules || [];
}

export function getVisibleFooterModules(footer) {
    return getFooterModules(footer).filter((module) => module?.type !== SectionModuleTypeEnum.SPACER);
}